import React from 'react';
import Icon from '../../AppIcon';

const DestimeTopActionItem = ({ action, index, formatDuration }) => {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 rounded-md bg-muted/40 border border-border flex items-center justify-center overflow-hidden">
          {action?.iconUrl ? (
            <img src={action.iconUrl} alt={action.title} className="w-full h-full object-cover" />
          ) : (
            <Icon name={action?.iconName || 'Timer'} size={18} />
          )}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-medium text-foreground truncate">{action?.title}</div>
          <div className="text-xs text-muted-foreground caption">#{index + 1}</div>
        </div>
      </div>
      <div className="text-sm font-semibold text-foreground">{formatDuration?.(action?.minutes)}</div>
    </div>
  );
};

export default DestimeTopActionItem;
